import { Color } from "./types";

export type ColorStr = "green" | "yellow" | "black";

export function getColor(color: Color): ColorStr {
  return color === "⬛" ? "black" : color === "🟨" ? "yellow" : "green";
}
